export const isLIFF = () => {
  return typeof navigator !== 'undefined' && /line/.test(navigator.userAgent.toLowerCase()) ? 'line' : undefined;
};

export const isPWA = () => {
  return (
    typeof navigator !== 'undefined' &&
    typeof window !== 'undefined' &&
    typeof document !== 'undefined' &&
    ('standalone' in window.navigator || // iOS PWA Standalone
      document.referrer.includes('android-app://') || // Android Trusted Web App
      ['fullscreen', 'standalone', 'minimal-ui'].some(
        (displayMode) => window.matchMedia(`(display-mode: ${displayMode})`).matches
      ))
  );
};

export const isAndroid = () => {
  return typeof navigator !== 'undefined' && /android/i.test(navigator.userAgent);
};

export const isIPhone = () => {
  return typeof navigator !== 'undefined' && /iPhone/.test(navigator.userAgent);
};

export const isIPad = () => {
  if (typeof navigator === 'undefined') return false;
  // iPadOS 13+ はデスクトップ UA で Macintosh を報告する（platform は非推奨のため UA + タッチで判定）
  const isIpadOsDesktopUa = /Macintosh/i.test(navigator.userAgent) && navigator.maxTouchPoints > 1;
  return /iPad/.test(navigator.userAgent) || isIpadOsDesktopUa;
};

// iOS WebKit の react-pdf/OffscreenCanvas 関連メモリ問題(pdf.js #18985)向け判定。iPod は含まない(pdfOptions側で別途考慮)。
export const isIOSWebKit = () => {
  return isIPhone() || isIPad();
};
